import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-mist relative" data-id="element-180" data-mp="1jb1sug4wmy7r">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-181" data-mp="1n9r33zunbzn6">
        <div className="text-center mb-10" data-id="element-182" data-mp="1s9des4utt7tv">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-navy uppercase" data-id="element-183" data-mp="1s8c6u993x1gd">
            Your Complete <span className="text-cta" data-id="element-184" data-mp="1x99nghegxnfr">Scuba Diving Instructor Ready</span> Package
          </h2>
          <p className="text-slate-700 text-sm md:text-base" data-id="element-185" data-mp="227b46vof9ao2">
            Everything You Need to Plan Less and Teach With More Structure
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-navy border-2 border-cta rounded-3xl p-1 relative shadow-xl shadow-navy/15" data-id="element-186" data-mp="7t0e6jw3cagp">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-cta text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-187" data-mp="1crn1ptmir8al">
            <Sparkles size={14} data-id="element-188" data-mp="25f0r96nw11ko" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-189" data-mp="20g68u5tu1f13">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-xl h-auto mx-auto mb-6" loading="lazy" data-id="element-190" data-mp="1vh328gy7f0r0" />

            <p className="text-sm font-bold tracking-widest text-ocean mb-3" data-id="element-191" data-mp="k27pj0j4b9d3">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream border border-cta/20 rounded-xl p-4" data-id="element-192" data-mp="g0m42qsipmra">
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-193" data-mp="hijhfod97v3x" data-mpi={itemIndex}>
                  {itemIndex === 6 && <li className="pt-2 text-xs font-bold tracking-widest text-cta" data-id="element-194" data-mp="mg3339ca7a5w">PLUS:</li>}
                  <li className="flex items-start gap-2 text-sm text-ink" data-id="element-195" data-mp="7log6xpljgly">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-cta shrink-0 mt-0.5" data-id="element-196" data-mp="3uwxxe0f0jm8d" /> : <Check size={16} className="text-ocean shrink-0 mt-0.5" data-id="element-197" data-mp="3hqjetnquhw2" />}
                    <span data-id="element-198" data-mp="3kyqevd52sw49">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-199" data-mp="3pycvlwk44uht">
              <p className="text-sm text-slate-500 mb-1" data-id="element-200" data-mp="3pvgtrx559lo3">
                REGULAR VALUE: <span className="line-through" data-id="element-201" data-mp="3bybvwkfl3t3x">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-202" data-mp="3fyc6tv3h5m68">
                <span className="text-2xl md:text-3xl text-slate-600" data-id="element-203" data-mp="2xalbzniffh35">TODAY:</span>
                <span className="text-4xl md:text-5xl font-serif font-extrabold text-cta" data-id="element-204" data-mp="2sc9y91p0gmfn">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-205" data-mp="369f16stfh56o">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-206" data-mp="3bbnxnz5iepdj">
              <span className="flex items-center gap-1.5" data-id="element-207" data-mp="3p2iyco5uu061">
                <Lock size={12} className="text-ocean" data-id="element-208" data-mp="3p43tofzztn4y" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-209" data-mp="3l2sb2ufje269">
                <Zap size={12} className="text-ocean" data-id="element-210" data-mp="2w47j904xn2p" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-211" data-mp="3u2f2qoigrtm4">
                <Wallet size={12} className="text-ocean" data-id="element-212" data-mp="hy2ml11ty51b" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}